module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "datatable"
    }
  }, [_c('v-data-table', {
    attrs: {
      "single-select": "",
      "headers": _vm.headers,
      "items": _vm.items,
      "page": _vm.currentPage,
      "items-per-page": _vm.visibleRow.value,
      "hide-default-footer": "",
      "item-key": "no",
      "loading-text": "Loading... Please wait"
    },
    on: {
      "update:page": function($event) {
        _vm.currentPage = $event
      },
      "dblclick:row": _vm.selectRowAndFinish
    },
    scopedSlots: _vm._u([{
      key: "top",
      fn: function() {
        return [_c('v-card-text', {
          staticClass: "pa-0"
        }, [_c('v-container', {
          attrs: {
            "fluid": ""
          }
        }, [_c('v-row', {
          attrs: {
            "no-gutters": ""
          }
        }, [_c('v-col', [_c('v-text-field', {
          staticClass: "search_box",
          attrs: {
            "id": "datatable_search",
            "outlined": "",
            "height": "36px",
            "hide-details": "",
            "small": "",
            "dense": "",
            "placeholder": "Ketik kata kunci dan tekan enter"
          },
          on: {
            "keyup": function($event) {
              if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
              return _vm.doBasicFilter()
            }
          },
          model: {
            value: (_vm.query),
            callback: function($$v) {
              _vm.query = $$v
            },
            expression: "query"
          }
        }, [_c('template', {
          slot: "prepend-inner"
        }, [_c('svg', {
          attrs: {
            "width": "20",
            "height": "20",
            "viewBox": "0 0 20 20",
            "fill": "none",
            "xmlns": "http://www.w3.org/2000/svg"
          }
        }, [_c('path', {
          attrs: {
            "d": "M8.33342 15.0001C9.81256 14.9998 11.2491 14.5046 12.4142 13.5934L16.0776 17.2567L17.2559 16.0784L13.5926 12.4151C14.5042 11.2498 14.9997 9.81295 15.0001 8.33341C15.0001 4.65758 12.0092 1.66675 8.33342 1.66675C4.65758 1.66675 1.66675 4.65758 1.66675 8.33341C1.66675 12.0092 4.65758 15.0001 8.33342 15.0001ZM8.33342 3.33341C11.0909 3.33341 13.3334 5.57591 13.3334 8.33341C13.3334 11.0909 11.0909 13.3334 8.33342 13.3334C5.57591 13.3334 3.33341 11.0909 3.33341 8.33341C3.33341 5.57591 5.57591 3.33341 8.33342 3.33341Z",
            "fill": "#073554"
          }
        }), _vm._v(" "), _c('path', {
          attrs: {
            "d": "M9.50994 7.15507C9.82577 7.47174 9.99994 7.89007 9.99994 8.33341H11.6666C11.6673 7.89543 11.5813 7.46165 11.4133 7.05714C11.2454 6.65264 10.999 6.28543 10.6883 5.97674C9.4266 4.71674 7.2391 4.71674 5.97827 5.97674L7.15494 7.15674C7.78827 6.52507 8.87994 6.52674 9.50994 7.15507Z",
            "fill": "#073554"
          }
        })])])], 2)], 1)], 1)], 1)], 1)]
      },
      proxy: true
    }, {
      key: "item.status",
      fn: function(ref) {
        var item = ref.item;

        return [(item.status === 'TO_DO') ? _c('v-btn', {
          staticStyle: {
            "color": "#ffffff"
          },
          attrs: {
            "small": "",
            "depressed": "",
            "rounded": "",
            "color": "#EB3123"
          }
        }, [_vm._v("\n                To Do\n            ")]) : _vm._e(), _vm._v(" "), (item.status === 'DONE') ? _c('v-btn', {
          staticStyle: {
            "color": "#00cf3f"
          },
          attrs: {
            "small": "",
            "depressed": "",
            "rounded": "",
            "color": "#BCF8CC"
          }
        }, [_vm._v("\n                Done\n            ")]) : _vm._e(), _vm._v(" "), (item.status === 'IN_PROGRESS') ? _c('v-btn', {
          staticStyle: {
            "color": "#0e97d6"
          },
          attrs: {
            "small": "",
            "depressed": "",
            "rounded": "",
            "color": "#E1F4FC"
          }
        }, [_vm._v("\n                In Progress\n            ")]) : _vm._e()]
      }
    }, {
      key: "item.actions",
      fn: function(ref) {
        var item = ref.item;

        return [(_vm.hasAction) ? _c('v-menu', {
          attrs: {
            "offset-y": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;
              var attrs = ref.attrs;

              return [_c('div', _vm._g(_vm._b({
                attrs: {
                  "icon": ""
                }
              }, 'div', attrs, false), on), [_c('v-icon', {
                attrs: {
                  "color": "#4F4F4F",
                  "id": "datatable_dot_btn"
                }
              }, [_vm._v("mdi-dots-vertical")])], 1)]
            }
          }], null, true)
        }, [_vm._v(" "), _c('v-list', [_c('v-list-item', {
          staticClass: "test_cursor",
          attrs: {
            "link": ""
          },
          on: {
            "click": function($event) {
              return _vm.updateItem(item)
            }
          }
        }, [_c('v-list-item-title', [_vm._v("Edit")])], 1)], 1)], 1) : _vm._e()]
      }
    }, {
      key: "item.no",
      fn: function(ref) {
        var index = ref.index;

        return [_vm._v("\n            " + _vm._s(_vm.items.length * (_vm.currentPage - 1) + (index + 1)) + "\n        ")]
      }
    }], null, true)
  }), _vm._v(" "), _c('div', {
    staticClass: "d-flex space-between pa-4"
  }, [_c('span', {
    staticClass: "gray3--text"
  }, [_vm._v("\n            Menampilkan " + _vm._s(_vm.items.length * _vm.currentPage) + " dari -\n        ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "pa-0",
    attrs: {
      "depressed": "",
      "disabled": _vm.currentPage == 1,
      "min-width": "32px",
      "height": "32px"
    },
    on: {
      "click": function($event) {
        return _vm.goToPage(--_vm.currentPage)
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-chevron-left")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "pa-0 mx-2",
    attrs: {
      "depressed": "",
      "dark": "",
      "color": "blew",
      "min-width": "32px",
      "height": "32px"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.currentPage) + "\n        ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "pa-0",
    attrs: {
      "depressed": "",
      "min-width": "32px",
      "height": "32px",
      "disabled": _vm.items.length < _vm.customPaginationPerPage
    },
    on: {
      "click": function($event) {
        return _vm.goToPage(++_vm.currentPage)
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-chevron-right")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-64597d2c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/global/components/plugins/DataTable-s.vue
// module id = 2117
// module chunks = 1